var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* tslint:disable: cyclomatic-complexity */
/* istanbul ignore file */
import { observable, computed, action } from "mobx";
import { TimeHelpers } from "../../../helpers";
export class Jackpot {
    constructor(jackpotId, incPeriod, incValue) {
        this.maxValue = 0;
        this.tickerSynced = false;
        this.isAvailableCallbackFnArr = [];
        this.currentValueReachesMaxValue = false;
        this.atLeastOneRealUpdate = false;
        this.isInProgress = true;
        this.id = jackpotId;
        this.description = "";
        this.name = "";
        this.lastUpdateTime = TimeHelpers.getCurrentDateTimeUTC();
        this.incrementPeriod = incPeriod;
        this.incrementValue = incValue;
    }
    /* istanbul ignore next */
    get IsWithoutRealUpdates() {
        return !this.atLeastOneRealUpdate;
    }
    get IsWon() {
        return !this.isInProgress;
    }
    /* istanbul ignore next */
    update(source) {
        if (source.id !== this.id) {
            return;
        }
        this.currencyId = source.currencyId;
        !this.maxDropDate && (this.maxDropDate = Date.fromISO(source.endDate));
        //priority by CMS configuration
        !this.name && source.externalName && (this.name = source.externalName);
        !this.description && source.externalDescription && (this.description = source.externalDescription);
        //skip ticker update cuz it has own endpoint for last value update
        if (this.IsWon) {
            return;
        }
        if (source.currentValue === source.maxValue) {
            this.currentValueReachesMaxValue = true;
        }
        this.maxValue = source.maxValue;
        if (source.currentValue > this.maxValue) {
            source.currentValue = this.maxValue;
        }
        //this will re-init simulation based on latest synced value
        this.tickerSynced = true;
        this.tickerValue = source.currentValue;
        //TODO actually make sense for IsCountdownType + less 24h
        this.lastUpdateTime = TimeHelpers.getCurrentDateTimeUTC();
        return this;
    }
    //used as endpoint for approximate ticker update
    /* istanbul ignore next */
    updateTicker(currentValue) {
        //if maxValue = currentValue, no need request latest update,
        // as we only get infinity cycle which request latest update all the time
        if (this.IsWon || this.currentValueReachesMaxValue) {
            return;
        }
        let needToRequestLatest = false;
        if (currentValue > this.maxValue) {
            this.tickerValue = this.maxValue;
            needToRequestLatest = true;
        }
        else if (!this.tickerSynced) {
            this.tickerValue = currentValue;
        }
        else {
            //reset flag so next simulation will succeed after re-init
            this.tickerSynced = false;
        }
        //TODO actually make sense for IsCountdownType + less 24h
        this.lastUpdateTime = TimeHelpers.getCurrentDateTimeUTC();
        return {
            tickerValue: this.tickerValue,
            needToRequestLatest
        };
    }
    /* istanbul ignore next */
    addIsAvailableCallbackFn(isAvailableCallbackFn) {
        this.isAvailableCallbackFnArr.push(isAvailableCallbackFn);
    }
    /* istanbul ignore next */
    emitIsAvailableChange(isAvailable) {
        //based on this flag we include or don't include this JP for next data update
        this.atLeastOneRealUpdate = isAvailable;
        this.isAvailableCallbackFnArr.forEach(fn => fn(isAvailable));
    }
    /* istanbul ignore next */
    markAsWon(lastTickerValue) {
        this.isInProgress = false;
        this.tickerValue = lastTickerValue;
        this.lastUpdateTime = TimeHelpers.getCurrentDateTimeUTC();
        ;
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], Jackpot.prototype, "currencyId", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], Jackpot.prototype, "tickerValue", void 0);
__decorate([
    observable,
    __metadata("design:type", Date)
], Jackpot.prototype, "maxDropDate", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], Jackpot.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], Jackpot.prototype, "lastUpdateTime", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Jackpot.prototype, "atLeastOneRealUpdate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Jackpot.prototype, "isInProgress", void 0);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Jackpot.prototype, "IsWithoutRealUpdates", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Jackpot.prototype, "IsWon", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Jackpot.prototype, "update", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], Jackpot.prototype, "updateTicker", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], Jackpot.prototype, "emitIsAvailableChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], Jackpot.prototype, "markAsWon", null);
//# sourceMappingURL=Jackpot.js.map